export const GET_RANDOM_NUMBER = 'GET_RANDOM_NUMBER';
